module.exports = __webpack_public_path__ + "static/media/Initial_pca.7175db20.png";